import { FirmsPageAction, FirmsPageState } from './interfaces';

export const initialState: FirmsPageState = {
  crud: { open: false, record: null, mode: null },
  deleteModal: { open: false, record: null },
  changeLog: { target: null },
};

export function reducer(prevState: FirmsPageState, action: FirmsPageAction): FirmsPageState {
  switch (action.type) {
    case 'openCrud':
      if (!action.mode) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...initialState,
        crud: { open: true, record: action.record ?? null, mode: action.mode },
      };
    case 'closeCrud':
      return {
        ...initialState,
      };
    case 'openDeleteModal':
      if (!action.record) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        deleteModal: {
          open: true,
          record: action.record,
        },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: false,
          record: null,
        },
      };
    case 'openChangeLog':
      if (!action.changeLog) throw new Error(`Invalid action provided ${action.type}`);
      return {
        ...prevState,
        changeLog: action.changeLog,
      };
    case 'closeChangeLog':
      return {
        ...prevState,
        changeLog: initialState.changeLog,
      };
    default:
      throw new Error('No action provided');
  }
}
